module.exports = __webpack_public_path__ + "static/img/normal.ecb85de6.png";